<template>
  <modal :name="modalName" :click-to-close="false" :height="'auto'" :scrollable="true">
    <v-modal-content v-on:close="close" :title="modalMode === 'add' ? loc('addComplaint') : loc('editComplaint') ">
      <!-- <p class="ingress">{{loc('forms.messages.warrantyRequired')}}</p> -->
      <v-complaint-user-info :user-data="user" :company-data="company" ></v-complaint-user-info>
      <v-form :fields="fields" :form-data="formData" :form-errors="formErrors" :on-blur="onFieldBlur">
        <div slot="buttons">
          <p v-if="uploadingFile">{{loc('uploadingFile')}}: {{uploadingFile}} / {{totalFiles}}</p>
          <p v-else>&nbsp;</p>
          <button class="btn btn--cancel" type="button" v-on:click="close">{{loc('cancel')}}</button>
          <button :disabled="processing" v-if="modalMode === 'add'" type="submit" v-on:click="addComplaint" class="btn btn--white">{{loc('addComplaint')}}</button>
        </div>
      </v-form>
    </v-modal-content>
  </modal>
</template>

<script>

import VModalContent from './v-modal-content.vue';
import VComplaintUserInfo from './v-complaint-user-info.vue';
import VForm from './v-form.vue';

export default {
  components: {
    'v-modal-content': VModalContent,
    'v-complaint-user-info': VComplaintUserInfo,
    'v-form': VForm
  },
  name: 'ModalComplaint',
  props: ['on-close', 'modal-mode', 'modal-data'],
  data: function() {
    return {
      formErrors: {},
      formData: {},
      data: {},
      name: 'complaint',
      totalFiles: 0,
      uploadingFile: 0,
      processing: false,
      fetchedMachineName: '',
      fetchedDescription: '',
      fetchedProcedure: ''
    }
  },
  computed: {
    user() {
      return this.$store.state.user.info;
    },
    company() {
      return this.$store.state.user.company;
    },
    fields() {
      return this.getFields();
    },
    modalName() {
      return this.name + '-' + this.modalMode;
    }
  },
  methods: {
    onFieldBlur(data) {
      if(data.name == 'serialNumber') {
        if(this.formData.serialNumber) {
          // this.checkWarrantyRegistration(this.formData.serialNumber);
          this.getMachineName(this.formData.serialNumber);
        }
      }
    },
    checkWarrantyRegistration(serialNumber) {
      this.formErrors = {};
      const allowedSerialNumbers = this.$store.state.warrantedSerialNumbers;
      if (!allowedSerialNumbers.includes(serialNumber)) {
        this.formErrors = {
          fieldError: true,
          serialNumber:  {
            field: 'serialNumber',
            messages: [this.loc('forms.messages.notWarrantedSerialNumber')]
          }
        }
      }
    },
    increaseShowCount() {
      this.showCount++;
    },
    applyModalData() {
      this.formErrors = {};
      this.formData = {};
      this.data = {};
      this.fetchedMachineName = '';
      this.fetchedProcedure = '';

      if(this.$props.modalData) {
        Object.keys(this.$props.modalData).forEach(key => {
          this.data[key] = this.$props.modalData[key];
        });
      }

      this.increaseShowCount();
    },
    getFields() {
      // Initialize form depending on modal mode
      if(this.$props.modalMode === 'add') {
        return [{
          name: 'serialNumber',
          value: this.data.serialNumber,
          label: this.loc('serialNumber'),
          type: 'text'
        }, {
          name: 'name',
          value: this.data.name || this.fetchedMachineName,
          label: this.loc('name'),
          type: 'text'
        }, {
          name: 'referenceId',
          value: this.data.referenceId,
          label: this.loc('forms.labels.complaintReference'),
          type: 'text'
        },{
          name: 'description',
          value: this.data.description || this.fetchedDescription,
          placeholder: this.loc('forms.placeholders.complaintDescription'),
          label: this.loc('forms.labels.complaintDescription'),
          type: 'textarea'
        },{
          name: 'descriptionDate',
          value: this.data.descriptionDate,
          label: this.loc('forms.labels.complaintDescriptionDate'),
          type: 'date'
        },{
          name: 'procedure',
          value: this.data.procedure || this.fetchedProcedure,
          //placeholder: this.loc('forms.placeholders.complaintProcedure'),
          label: this.loc('forms.labels.complaintProcedure'),
          type: 'textarea'
        },{
          name: 'procedureDate',
          value: this.data.procedureDate,
          label: this.loc('forms.labels.complaintProcedureDate'),
          type: 'date'
        },{
          name: 'accessories',
          label: this.loc('forms.labels.complaintAccessories'),
          type: 'data-items',
          sumField: 'price',
          multiplyField: 'amount',
          hideEmpty: true,
          value: [],
          fields: [
          {
            label: this.loc('complaintAccessories.name'),
            placeholder: this.loc('complaintAccessories.name'),
            type: 'text',
            name: 'name'
          }, {
            label: this.loc('complaintAccessories.id'),
            placeholder: this.loc('complaintAccessories.id'),
            type: 'text',
            name: 'id'
          }, {
            label: this.loc('complaintAccessories.amount'),
            placeholder: this.loc('complaintAccessories.amount'),
            type: 'number',
            name: 'amount'
          }, {
            label: this.loc('complaintAccessories.price'),
            placeholder: this.loc('complaintAccessories.price'),
            type: 'currency',
            name: 'price'
          }]
        }, {
          name: 'services',
          label: this.loc('forms.labels.complaintJobs'),
          type: 'data-items',
          sumField: 'price',
          multiplyField: 'hours',
          hideEmpty: true,
          value: [],
          fields: [
          /*{
            label: this.loc('complaintServices.name'),
            placeholder: this.loc('complaintServices.name'),
            type: 'text',
            name: 'name'
          },*/
          {
            label: this.loc('complaintServices.hours'),
            placeholder: this.loc('complaintServices.hours'),
            type: 'number',
            name: 'hours'
          },{
            label: this.loc('complaintServices.price'),
            placeholder: this.loc('complaintServices.price'),
            type: 'currency',
            name: 'price'
          }]
        }, {
          name: 'files',
          multiple: true,
          value: [],
          type: 'file'
        }]
      } else if(this.$props.modalMode === 'edit') {
        // Not yet implemented
      }
    },
    show() {
      this.applyModalData();
      this.$modal.show(this.modalName);
    },
    close(data) {
      if(this.onClose) {
        if(!data) {
          data = {
            status: 'cancel'
          };
        }
        this.onClose(data);
      }
      this.$modal.hide(this.modalName);
    },
    async getMachineName(serialNumber) {

      let formDataBackup = this.formData;

      let res = await this.$api.getCustomerMachine(serialNumber);

      if(res.code == 200) {
        if(res.result.hasOwnProperty('customerMachine')) {
          this.formData.name = res.result.customerMachine.machineType;
          this.fetchedMachineName = res.result.customerMachine.machineType;
          this.formData.description = formDataBackup.description;
          this.data.description = this.formData.description;
          this.formData.descriptionDate = formDataBackup.descriptionDate;
          this.data.descriptionDate = this.formData.descriptionDate;
          this.formData.procedure = formDataBackup.procedure;
          this.data.procedure = this.formData.procedure;
          this.formData.procedureDate = formDataBackup.procedureDate;
          this.data.procedureDate = this.formData.procedureDate;
          this.data.serialNumber = serialNumber
          this.formData.serialNumber = serialNumber;
        }
      }

      if(res.code === 400) {
        this.fetchedMachineName = '';
        this.formData.name = '';
        return;
      }

      if(res.code !== 200) {
        this.formData.name = '';
        return;
      }
    },
    async addComplaint() {
      this.processing = true;

      let res = await this.$api.addComplaint({
        serialNumber: this.formData.serialNumber,
        description: this.formData.description,
        descriptionDate: this.formData.descriptionDate,
        procedure: this.formData.procedure,
        procedureDate: this.formData.procedureDate,
        referenceId: this.formData.referenceId,
        accessories: this.formData.accessories,
        services: this.formData.services
        //accessoriesText: this.formData.accessoriesText,
        //jobsText: this.formData.jobsText
      })

      if(res.code === 400) {
        this.formErrors = res.result.fields;
        this.processing = false;
        return;
      }

      if(res.code !== 200) {
        this.processing = false;
        return;
      }
      // Upload files to that complaint
      // We want to upload them in series, so that we don't get conflicts when updating the results to database
      const complaint = res.result.complaint;
      const complaintId = res.result.complaint.uuid;

      //send form event stuff to Google Tag Manager dataLayer
      var gaEvent = {
        event: 'reclamationFormSubmit',
        reclamationId: complaintId,
        reclamationSerial: this.formData.serialNumber
      };
      if(typeof dataLayer != 'undefined'){
        dataLayer.push(gaEvent);
      }

      this.totalFiles = this.formData.files.length;
      this.uploadingFile = 0;

      for(let i = 0, l = this.formData.files.length; i<l; i++) {
        const file = this.formData.files[i];

        this.uploadingFile++;

        res = await this.$api.addComplaintFile(complaintId, {
          file: file.file
        });

        if(res.code !== 200) {
          this.processing = false;
          return;
        }
      }

      // Save state of a complaint without possible files
      this.$store.commit('addComplaint', complaint);

      // And trigger fetching of full complaint with files included
      this.$store.dispatch('getComplaint', complaintId);

      this.processing = false;
      this.close({status: 'success'});
    }
  },
  watch: {
    modalData() {
      this.applyModalData();
    }
  }
}
</script>
